import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _isEmpty from 'lodash/isEmpty';
import _isNumber from 'lodash/isNumber';
import _forEach from 'lodash/forEach';
import _startCase from 'lodash/startCase';
import _lowerCase from 'lodash/lowerCase';
import _omit from 'lodash/omit';
import _castArray from 'lodash/castArray';
import _get from 'lodash/get';
import _chunk from 'lodash/chunk';
import _omitBy from 'lodash/omitBy';
import _uniqBy from 'lodash/uniqBy';
import _compact from 'lodash/compact';
import _map from 'lodash/map';
import TEnvReader from 'tbase/readers/Env';
import Money from 'tbase/utils/money';
import { EMPTY_ARRAY, EMPTY_OBJECT, EMPTY_STRING } from 'tbase/app.constants';
import { formatCurrency } from 'tbase/formatters/formatCurrency';
import { toMomentDuration, getTimeStamp, startOfDay, isMomentValid, toMoment } from 'tbase/utils/dateUtils';
export function findArrayIndex(array, key, value) {
  if (Array.isArray(array)) {
    return array.findIndex(function (item) {
      return item[key] === value;
    });
  }

  return -1;
}
export function arrayFilter(array, key, value) {
  return array.filter(function (item) {
    return item[key] === value;
  });
}
export function removeMatchedItems(array, key, value) {
  return array.filter(function (item) {
    return item[key] !== value;
  });
}
export function omitKeys(object, keys) {
  return _omit(object, keys);
}
export var isObjectPropertiesEmpty = function isObjectPropertiesEmpty(collection) {
  if (_isEmpty(collection)) return true;
  var result = false;

  _forEach(collection, function (value) {
    if (typeof value !== 'number' && _isEmpty(value)) {
      result = true;
    }
  });

  return result;
};
export var getRandomId = function getRandomId() {
  return (Date.now().toString(36) + Math.random().toString(36).substr(2, 5)).toUpperCase();
};
export var transformObjectValuesToString = function transformObjectValuesToString(object) {
  return !_isEmpty(object) && Object.keys(object).map(function (value) {
    return object[value] || '';
  }).filter(function (value) {
    return value;
  }).join(' | ');
};
export var transformObjectToKeyValue = function transformObjectToKeyValue(object) {
  return !_isEmpty(object) && Object.keys(object).map(function (key) {
    return {
      key: _startCase(key),
      value: object[key]
    };
  });
};
export var appendPercentage = function appendPercentage(string) {
  return string && "".concat(string, "%");
};
export var uuid = function uuid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0; // eslint-disable-line

    var v = c == 'x' ? r : r & 0x3 | 0x8; // eslint-disable-line

    return v.toString(16);
  });
};
export var getArrayLength = function getArrayLength(a) {
  return Array.isArray(a) ? a.length : 0;
};
export function findArrayItem(array, key, value) {
  if (Array.isArray(array)) {
    return array.find(function (item) {
      return item[key] === value;
    });
  }

  return null;
}
export function findArrayItemWithMatchingkeys(array, keys, values) {
  if (!Array.isArray(keys) || !Array.isArray(values)) return null;
  if (keys.length !== values.length) return null;

  if (Array.isArray(array)) {
    return array.find(function (item) {
      var available = false;
      keys.forEach(function (key, index) {
        if (item[key] === values[index]) {
          available = true;
        }
      });
      return available;
    });
  }

  return null;
}
export function getNumber(stringData) {
  var result = Number(stringData);
  return !result || isNaN(result) ? 0 : result; //eslint-disable-line
}
export function removeFromArray() {
  var srcArray = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_ARRAY;
  var arrayToRemove = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : EMPTY_ARRAY;
  return srcArray.filter(function (item) {
    return !arrayToRemove.includes(item);
  });
}
export var convertUnicode = function convertUnicode(input) {
  return input.replace(/\\u(\w\w\w\w)/g, function (a, b) {
    var charcode = parseInt(b, 16);
    return String.fromCharCode(charcode);
  });
};
export var getFileList = function getFileList() {
  var fileData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_OBJECT;

  var file = _get(fileData, 'file', EMPTY_ARRAY);

  var fileList = _castArray(file);

  return fileList;
};
export var toTitleCase = function toTitleCase(str) {
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
};
export var snakeCaseToStartCase = function snakeCaseToStartCase(str) {
  return str && _startCase(_lowerCase(str));
};
export var createStringFromArray = function createStringFromArray() {
  var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ', ';
  return arr.filter(function (element) {
    return element && typeof element === 'string';
  }).join(separator);
};
export function findAndReplaceMatchedItems(array, key, value, replacementValue) {
  var updatedArray = _toConsumableArray(array);

  var foundIndex = findArrayIndex(array, key, value);

  if (foundIndex !== -1) {
    updatedArray[foundIndex] = replacementValue;
  }

  return updatedArray;
}
export var getResponse = function getResponse(response) {
  return _get(response, 'response');
};
export var getDaysFromDuration = function getDaysFromDuration(duration) {
  var precisedDate = Number(duration).toPrecision();
  var momentDuration = toMomentDuration(Number(precisedDate));
  return Math.floor(momentDuration.asDays());
};
export var getGlobalPusherChannelName = function getGlobalPusherChannelName() {
  var _TEnvReader$userInfo = TEnvReader.userInfo(),
      tenantName = _TEnvReader$userInfo.tenantName,
      dealerId = _TEnvReader$userInfo.dealerId,
      id = _TEnvReader$userInfo.id;

  return "USER_".concat(tenantName, "_").concat(dealerId, "_").concat(id);
};
export function convertToLowerCase() {
  var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return string.toLowerCase();
}
export var getGeneratedFormSections = function getGeneratedFormSections(keys) {
  var groupedFields = _chunk(keys, 2);

  return groupedFields.map(function (fields) {
    return {
      columns: fields
    };
  });
};
export function getNumericValueForFormFields(stringData) {
  if (stringData !== '') {
    var result = Number(stringData);
    return isNaN(result) ? undefined : result; //eslint-disable-line
  }

  return stringData;
}
export function removeZeroAmount(data) {
  return data.filter(function (item) {
    var amount = _get(item, 'amount') || 0;
    return getNumber(amount) !== 0;
  });
}
export var removeFalseValues = function removeFalseValues(obj) {
  return _omitBy(obj, function (val) {
    return !val;
  });
};
export var isNumber = function isNumber(number) {
  if (typeof number === 'string') return _isNumber(Number(number));
  return _isNumber(number);
};
export var getUnformattedPhoneNumber = function getUnformattedPhoneNumber(str) {
  return (str || EMPTY_STRING).replace(/[\s()-]/g, '');
};
export var getUnformattedSSN = function getUnformattedSSN(str) {
  return (str || EMPTY_STRING).replace(/[\s-]/g, '');
};
export function calculatePercentage(numerator, denominator) {
  return Number(((denominator ? numerator / denominator : 0) * 100).toFixed(2));
}
export var formatCurrencyWithMoneyFormat = function formatCurrencyWithMoneyFormat(value) {
  var monetaryValue = Money.format(value);
  return formatCurrency(monetaryValue);
};
export var addPrices = function addPrices(prices) {
  return (prices || EMPTY_ARRAY).reduce(function (total, price) {
    return Money.add(total, getNumber(price));
  }, 0);
};
export var getNumberFromString = function getNumberFromString(str) {
  return ((str || '').match(/\d+/g) || []).join('');
};
export function getLenderCodeName(lenders, lenderId) {
  var mathchedLender = findArrayItem(lenders, 'id', lenderId);
  return _get(mathchedLender, 'codeName') || '';
}
export function getLenderCodeNameOfLender(lender) {
  return _get(lender, 'codeName') || '';
}
export var getFormattedROPrice = function getFormattedROPrice(price) {
  return _isNumber(price) ? price / 100 : price;
};
export function uniqueValues(array, key) {
  return _uniqBy(array, key);
}
export function arraySumBasedOnKey(array) {
  var accumulator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  return (array || EMPTY_ARRAY).reduce(function (total, item) {
    var price = _get(item, key) || 0;
    return Money.add(total, getNumber(price));
  }, accumulator);
}
export var getNumberValueFromEvent = function getNumberValueFromEvent(event) {
  var value = event.target.value;
  return value ? Number(value) : value;
};
export function isObjectsDifferentForKeys(oldObject, newObject, keysToCheck) {
  var isSame = true;
  keysToCheck.forEach(function (key) {
    if (_get(oldObject, key) !== _get(newObject, key)) {
      isSame = false;
    }
  });
  return !isSame;
} // to sort on number always send inn this format

export var arraySort = function arraySort(a, b) {
  var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'ASC';

  if (type === 'ASC') {
    return a.value - b.value;
  }

  return b.value - a.value;
};
export var isAPISuccessFromRawResponse = function isAPISuccessFromRawResponse(response) {
  return _get(response || {}, 'rawResponse.data.status') === 'success';
};
export var getStartOfDayTimeStamp = function getStartOfDayTimeStamp(momentObj) {
  if (isMomentValid(momentObj)) return getTimeStamp(startOfDay(momentObj));
  return null;
};
export var isEmpty = function isEmpty(value) {
  if (typeof value === 'number') return !value;
  return _isEmpty(value);
};
export var filterArrayByKey = function filterArrayByKey(array, key) {
  return (array || EMPTY_ARRAY).filter(function (_ref) {
    var filterKey = _ref[key];
    return !isEmpty(filterKey);
  });
};
export var removeInvalidArrayItemsIfArray = function removeInvalidArrayItemsIfArray(value) {
  return Array.isArray(value) ? _compact(value) : value;
};
export var getOptionsByKeyValuePair = function getOptionsByKeyValuePair(obj) {
  return _map(obj || {}, function (value, key) {
    return {
      label: value,
      value: key
    };
  });
};
export var addUUIDs = function addUUIDs(list) {
  return (list || []).map(function (item) {
    return _objectSpread(_objectSpread({}, item), {}, {
      id: uuid()
    });
  });
};
export var getCalendarDateDisplay = function getCalendarDateDisplay(epochOrMomentObject, RELATIVE_DATE_FORMAT) {
  return toMoment(epochOrMomentObject).calendar(null, RELATIVE_DATE_FORMAT);
};
export var isCreatedBySystem = function isCreatedBySystem(userId) {
  return getNumber(userId) === -1;
};
/**
 * similar to _uniqBy but doesn't remove duplicate empty values
 * @param {Array} arr - must be array of objects, use _uniq for rest use cases
 * @param {String} key - must be of type 'a.b.c' or simply 'a'
 */

export var getEmptyOrUniqValues = function getEmptyOrUniqValues(arr, key) {
  var uniqueArr = [];

  if (!_isEmpty(key) && !_isEmpty(arr) && typeof key === 'string') {
    var splittedKey = key.split('.');
    arr.forEach(function (item) {
      var valueInArr = _get(item, splittedKey);

      if (!valueInArr || !uniqueArr.find(function (uniqueItem) {
        return _get(uniqueItem, splittedKey) === valueInArr;
      })) uniqueArr.push(item);
    });
  }

  return uniqueArr;
};
export var convertToPlainArray = function convertToPlainArray(array, key) {
  return _map(array, function (item) {
    return _get(item, key);
  });
};